import { render } from "./ModalBoletines.vue?vue&type=template&id=7b071c5d&scoped=true"
import script from "./ModalBoletines.vue?vue&type=script&lang=js"
export * from "./ModalBoletines.vue?vue&type=script&lang=js"

import "./ModalBoletines.vue?vue&type=style&index=0&id=7b071c5d&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7b071c5d"

export default script